import { createElement } from 'react';
import { Button } from '@bedrock/components';
const LcButton = function LcButton(props) {
    return createElement(Button, { ...props }, "fusion button");
};
LcButton.displayName = 'LcButton';
export default LcButton;
